import { getHeaderTabMenu, getAsideTabMenu } from '@/api/tabs'
import store from '../index';
// 导航模块 tab && aside
const tabsModule = {
  namespaced: true,
  state() {
    return {
      isNavTipsShow: false,
      isAsideShow: false,
      isHeaderShow: false,
      headerTabMenu: [],
      asideTabMenu: [],
      routePath: null
    }
  },
  mutations: {
    changeNavShow(state) {
      state.isNavTipsShow = !state.isNavTipsShow
    },
    changeAsideShow(state, bool) {
      state.isAsideShow = bool
    },
    changeHeaderShow(state, bool) {
      state.isHeaderShow = bool
    },
    changeRoutePath(state, path) {
      state.routePath = path
    },
    getHeaderTabMenuData(state, headerMenu) {
      state.headerTabMenu = headerMenu
    },
    getAsideTabMenuData(state, asideMenu) {
      state.asideTabMenu = asideMenu
    },

  },
  actions: {


    async asyncGetHeaderTabMenuData({ commit }) {
      const { data: res } = await getHeaderTabMenu()
      if (res.code !== 200) {
        return Promise.reject(new Error('获取数据失败！'))
      } else {
        commit('getHeaderTabMenuData', res.data)
      }
    },

    async asyncGetAsideTabMenuData({ commit }, pid) {
      try {
        const { data: res } = await getAsideTabMenu(pid)
        console.log(res,'侧边栏');
        if (res.code !== 200) {
          return Promise.reject(new Error('获取数据失败！'))
        }
    
        // let processMenuItem = (item) => {
        //   if (store.state.m_user.users.leader === 1) {
        //     if (item.title === '待接案列表') {
        //       item.title = '待审批接案列表'
        //     } else if (item.title === '诉前在办') {
        //       item.title = '案管审批'
        //     }
        //   }
        //   return item
        // }
    
        // let  processMenu = (menu)=> {
        //   menu.forEach(item => {
        //     if (item.children) {
        //       processMenu(item.children)
        //     } else {
        //       item = processMenuItem(item)
        //     }
        //   })
        // }
    
        // processMenu(res.data)
        commit('getAsideTabMenuData', res.data)
      } catch (error) {
        return Promise.reject(error)
      }
    }
  },
  getters: {



  }
}
export default tabsModule
